import {
  CREATE_TUNNEL_NAME_INIT,
  ERROR_CLOUDFLARE_TUNEL,
  CREATE_TUNNEL_NAME_SUCCESS,
  CLEAR_CLOUDFLARE_TUNEL,
  REFRESH_TUNNEL_INIT,
  REFRESH_TUNNEL_SUCCESS,
  VALIDATE_CONNECTOR_INIT,
  VALIDATE_CONNECTOR_SUCCESS,
  CONFIGURE_ROTA_TUNNEL_INIT,
  CONFIGURE_ROTA_TUNNEL_SUCCESS,
  UPDATE_ETAPAS_TUNNEL_INIT,
  UPDATE_ETAPAS_TUNNEL_SUCCESS,
  DELETE_TUNNEL_INIT,
  DELETE_TUNNEL_SUCCESS
} from '../actionTypes';

const INIT_STATE = {
  isCreated: false,
  isRefreshed: false,
  isValidated: false,
  loading: false,
  loadingConector: false,
  isError: false,
  msg: '',
  connected: false,
  loadingConfigureService: false,
  configureServiceSuccess: false,
  tunnelExist: false,
  tunnelDeleted: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_TUNNEL_NAME_INIT:
      return { ...state, loading: true, isCreated: false };

    case CREATE_TUNNEL_NAME_SUCCESS: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        isCreated: true,
        msg
      };
    }
    case ERROR_CLOUDFLARE_TUNEL: {
      const { msg, isError } = action.payload;
      return {
        ...state,
        loading: false,
        isError,
        msg
      };
    }

    case REFRESH_TUNNEL_INIT:
      return {
        ...state,
        loading: true,
        isRefreshed: false,
        msg: ''
      };

    case REFRESH_TUNNEL_SUCCESS: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        isRefreshed: true,
        msg
      };
    }
    case VALIDATE_CONNECTOR_INIT:
      return {
        ...state,
        loadingConector: true,
        isValidated: false,
        msg: '',
        connected: false
      };

    case VALIDATE_CONNECTOR_SUCCESS: {
      const { msg, connected } = action.payload;
      return {
        ...state,
        loadingConector: false,
        isValidated: true,
        msg,
        connected
      };
    }

    case CONFIGURE_ROTA_TUNNEL_INIT:
      return {
        ...state,
        loadingConfigureService: true,
        configureServiceSuccess: false,
        tunnelExist: false,
        msg: ''
      };

    case CONFIGURE_ROTA_TUNNEL_SUCCESS: {
      const { msg, tunnelExist } = action.payload;
      return {
        ...state,
        loadingConfigureService: false,
        configureServiceSuccess: true,
        tunnelExist,
        msg
      };
    }

    case UPDATE_ETAPAS_TUNNEL_INIT:
      return {
        ...state,
        loading: true,
        etapasSalvas: false,
        error: null
      };

    case UPDATE_ETAPAS_TUNNEL_SUCCESS:
      return {
        ...state,
        loading: false,
        etapasSalvas: true
      };

    case DELETE_TUNNEL_INIT:
      return {
        ...state,
        loading: true,
        tunnelDeleted: false,
        msg: ''
      };

    case DELETE_TUNNEL_SUCCESS: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        tunnelDeleted: true,
        msg
      };
    }

    case CLEAR_CLOUDFLARE_TUNEL: {
      return { ...INIT_STATE };
    }

    default:
      return { ...state };
  }
};
